import { render, staticRenderFns } from "./Forumset.vue?vue&type=template&id=3bc592e4&scoped=true&"
import script from "./Forumset.vue?vue&type=script&lang=js&"
export * from "./Forumset.vue?vue&type=script&lang=js&"
import style0 from "./Forumset.vue?vue&type=style&index=0&id=3bc592e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc592e4",
  null
  
)

export default component.exports